import React from 'react';
import { Edit as IconEdit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

export default ({ project: { id }, className }) => (
  <Link to={`/project/edit/${id}`}>
    <Tooltip title="Edit project">
      <IconButton aria-label="Edit project" className={className}>
        <IconEdit />
      </IconButton>
    </Tooltip>
  </Link>
);
